import { css } from 'react-emotion';
import media from '../../mixins/mediaQueries';

const heading1 = css`
   font-size: 2em;
   font-weight: 700;
`;

const heading2 = css`
   font-size: 1.5em;
   font-weight: 700;
`;

const heading3 = css`
   font-size: 1.05em;
   font-weight: 700;
`;

const body = css`
   font-size: 1.2rem;
`;

const body1 = css`
   ${body};
`;

const body2 = css`
   ${body};
   font-weight: 600;
`;

const body3 = css`
   ${body};
   font-weight: 700;
`;

const body4 = css`
   ${body};
   font-style: italic;
`;

const caption = css`
   font-size: 0.8em;
`;

const caption1 = css`
   ${caption};
`;

const caption2 = css`
   ${caption};
   font-weight: 600;
`;

const caption3 = css`
   ${caption};
   font-weight: 700;
`;

const caption4 = css`
   ${caption};
   font-style: italic;
`;

const label = css`
   font-size: 1.05em;
`;

const label1 = css`
   ${label};
`;

const label2 = css`
   ${label};
   font-weight: 600;
`;

const label3 = css`
   ${label};
   font-weight: 700;
`;

const label4 = css`
   ${label};
   font-style: italic;
`;

const footer = css`
   font-size: 1.1rem;
   line-height: 1.1rem;
   ${media.tablet.style(css`
      font-size: 0.65rem;
      line-height: 0.65rem;
   `)};
`;

const link = css`
   font-size: 1em;
   text-decoration: underline;
`;

const link1 = css`
   ${link};
   font-weight: 600;
`;

const link2 = css`
   ${link};
   font-style: italic;
   text-decoration: underline;
   color: unset;
`;

const link3 = css`
   ${link};
   font-weight: 400;
`;

const styles = Object.freeze({
   heading1,
   heading2,
   heading3,
   body1,
   body2,
   body3,
   body4,
   caption1,
   caption2,
   caption3,
   caption4,
   label1,
   label2,
   label3,
   label4,
   footer,
   link1,
   link2,
   link3
});

export default styles;



// WEBPACK FOOTER //
// ./src/UI/themes/text/styles.js